module.exports = __webpack_public_path__ + "static/media/7-_DSC7439.35562dba.jpg";